import { _ep0, _mw0, command } from "../commandBuilder";
import { ListChurch$ } from "../schemas/schemas_0";
export class ListChurchCommand extends command(_ep0, _mw0, "ListChurch", ListChurch$) {
}
